// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"19":"a99a3896","168":"0bc60015","352":"41759caa","401":"22bf8bb6","446":"603deca0","744":"68fad095","858":"80e7a3fa","972":"586254d4"}[chunkId] + ".chunk.css";
};